import { useTranslation } from "react-i18next";
import { To } from "react-router";

import { AREA_LIST_PANEL_CONFIGS, STATUS_BY_AREA_LIST_PANEL } from "~/modules/plannerV2/constants/areaListPanelConfig";
import { getDefaultOpenPanel } from "~/modules/plannerV2/screens/PlannerV2Screen/PlannerV2AreasScreen/components/PlannerV2AreaLists/getDefaultOpenPanel";
import { useAreaListPanelToggle } from "~/modules/plannerV2/screens/PlannerV2Screen/PlannerV2AreasScreen/components/PlannerV2AreaLists/useAreaListPanelToggle";

import { PlannerV2AreasScreenAreaFragment } from "../../queries.generated";
import { PlannerV2AreaListMapPanel } from "../PlannerV2AreaListMapPanel";

type Props = {
    loading: boolean;
    plannerAreasPerStatusBucket: Record<string, PlannerV2AreasScreenAreaFragment[]>;
    visitOpenHref: (plannerAreaId: string, plannerVisitId: string) => To;
    areaNameHref: (plannerAreaId: string) => To;
};

export function PlannerV2AreaLists({ loading, plannerAreasPerStatusBucket, visitOpenHref, areaNameHref }: Props) {
    const { t } = useTranslation("plannerV2");

    const defaultOpenPanel = getDefaultOpenPanel(plannerAreasPerStatusBucket);
    const { togglePanel, isPanelOpen } = useAreaListPanelToggle(defaultOpenPanel);

    return (
        <>
            {AREA_LIST_PANEL_CONFIGS.map(({ key, translationKey }) => {
                const elements = STATUS_BY_AREA_LIST_PANEL[key].flatMap(status => {
                    return plannerAreasPerStatusBucket[status] ?? [];
                });

                return (
                    <PlannerV2AreaListMapPanel
                        loading={loading}
                        key={key}
                        title={t(translationKey)}
                        areas={elements}
                        panelIsOpen={isPanelOpen(key)}
                        onPanelOpenToggle={() => togglePanel(key)}
                        visitOpenHref={visitOpenHref}
                        areaNameHref={areaNameHref}
                    />
                );
            })}
        </>
    );
}
